import common from '../common';
import Scene from './Scene';

const _createButtons = Symbol('_createButtons');
const _createBackground = Symbol('_createBackground');
const _playBtnClick = Symbol('_playBtnClick');

export default class SplashScene extends Scene {
	constructor() {
		super();
		this._playBtn = null;
		this._muteBtn = null;

		this._titleSprite = null;
		this._titleText = null;
		this._logo = null;
	}

	init() {
		super.init();
		this[_createBackground]();
		this[_createButtons]();
	}

	appear() {
		this.animateIn();
	}

	animateIn() {
		new P3.utils.TWEEN.Tween(this._playBtn.scale, this.tweens)
		    .to({
		        x: 1, y: 1
		    }, 340)
		    .easing(P3.utils.Easing.Back3.Out)
		    .start();

		new P3.utils.TWEEN.Tween(this._muteBtn.scale, this.tweens)
			.to({
				x: 1, y: 1
			}, 340)
			.easing(P3.utils.Easing.Back2.Out)
			.start();
	}

	resize() {
		super.resize();
		this._muteBtn.x = (common.STAGE_WIDTH + P3.View.width) * 0.5 - 70;
		this._playBtn.x = common.STAGE_WIDTH * 0.5;
	}

	destroy() {
		// clean up goes here
		super.destroy();
	}

	update() {
		super.update();
	}

	/**
	 * creates background elements defined in levelConfig.splash
	 */
	[_createBackground]() {
		const bgConfig = common.levelConfig.splash.bg;
		const extrasConfig = common.levelConfig.splash.extra;

		for (const bgConfigElement of bgConfig)
			this.addChild(common.createSprite(bgConfigElement));

		for (const extraElement of extrasConfig)
			this.addChild(common.createSprite(extraElement));

		//create title
		const titleConfig = common.levelConfig.splash.title;
		const titlebg = common.createSprite(titleConfig);
		this.addChild(titlebg);

		//const langConfig = P3.assets.json('languages')['SPLASH_' + common.config.theme][common.config.language];
		const titleText = P3.createText('SPLASH_' + common.config.theme, {
			size: '32px',
			fill: common.levelConfig.splash.title.text_colour,
			stroke: common.levelConfig.splash.title.text_stroke ? '#000000': null,
			wordWrap: true,
			wordWrapWidth: 450
		}, 'truetype', null, ' LuckiestGuy');
		titleText.anchor = new PIXI.Point(0.5, 0.5);
		titleText.y += 5;
		titlebg.addChild(titleText);


		// 	new PIXI.extras.BitmapText(langConfig, {
		// 	font: '34px Luckiest Guy',
		// 	align: 'center'
		// });
		// titleText.y += titleText.height * 0.5;
		// titleText.anchor.set(0.5);
		// titlebg.addChild(titleText);
	}

	/**
	 * creates play and mute buttons
	 */
	[_createButtons]() {
		this._playBtn = createButton('play', 'primary_large');
		this._playBtn.anchor = new PIXI.Point(0.5, 0.5);
		this._playBtn.position = new PIXI.Point(
			common.STAGE_WIDTH * 0.5,
			common.STAGE_HEIGHT - 110);
		this._playBtn.overSoundName = 'sfx_ui_rollover_00';
		this._playBtn.downSoundName = 'sfx_btn_play_start_doorbell_00';
		this._playBtn.signals.click.once(this[_playBtnClick], this);
		this._playBtn.scale.set(0);
		this.addChild(this._playBtn);

		const states = new P3.ButtonStates();
		states.normal = P3.assets.texture('btn_primary_small_' + 'off');
		states.over = P3.assets.texture('btn_primary_small_' + 'over');
		states.down = P3.assets.texture('btn_primary_small_' + 'down');
		states.icon = P3.assets.texture('icon_sound');
		states.iconAlt = P3.assets.texture('icon_mute');

		this._muteBtn = new P3.MuteButton(states);

		this._muteBtn.position = new PIXI.Point(
			(common.STAGE_WIDTH + P3.View.width) * 0.5 - 70,
			this._muteBtn.height * 0.5 + 30
		);
		this._muteBtn.scale.set(0);
		this.addChild(this._muteBtn);
	}

	[_playBtnClick]() {
		this.signals.next.dispatch();
	}
}
